import { render } from "./status_body.vue?vue&type=template&id=fcaa2e0c"
import script from "./status_body.js?vue&type=script&lang=js"
export * from "./status_body.js?vue&type=script&lang=js"

import "./status_body.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "M:\\Viridian Patriots\\Server\\pleroma-fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__